export function savedCardCanSubmit({
  setupAvailable,
  consentAccepted,
  consentVersion,
  confirmed,
}) {
  return setupAvailable === true
    && consentAccepted === true
    && typeof consentVersion === 'string'
    && consentVersion.trim() !== ''
    && confirmed !== true;
}

export function savedCardStatusKey(method) {
  if (method?.confirmed === true && method?.status === 'active') {
    return 'stripe:savedCard.confirmed';
  }

  return 'stripe:savedCard.notConfirmed';
}
